import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CareTypeModal from './CareTypeModal';
import './Hero.css';

// Import hero images
import heroImage1 from '../assets/heroimage1.jpg';
import heroImage2 from '../assets/heroimage2.jpeg';
import heroImage3 from '../assets/heroimage3.png';
import winnerIcon from '../assets/winner.png';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <section className="hero" id="home">
         {/* Mobile Only Awards Section */}
          <div className="mobile-only-awards">
            <h3 className="awards-title">
              <img src={winnerIcon} alt="Award" className="award-icon" />
              Award-Winning Care
            </h3>
            <div className="award-source">Recognized as <strong>2025 Favorite Provider</strong> by Elko Daily Free Press Readers Choice Awards</div>
          </div>
      <div className="container" style={{ maxWidth: "1300px" }}>
        <div className="hero-content">
          <h1 style={{ color: 'rgb(179, 139, 109)' }}>Start your journey to better health today</h1>
          <p>Aspen Quick Care provides fast, reliable urgent care services when you need them most. Walk-ins welcome. Open 7 days a week with extended hours.</p>
          
          {/* Mobile Only Awards Section
          <div className="mobile-only-awards">
            <h3 className="awards-title">
              <img src={winnerIcon} alt="Award" className="award-icon" />
              Award-Winning Care
            </h3>
            <div className="award-source">Recognized as <strong>2025 Favorite Provider</strong> by Elko Daily Free Press Readers Choice Awards</div>
          </div> */}
          
          <div className="hero-buttons">
            <a href="#get-started" className="cta-button primary" onClick={handleGetStartedClick}>Get Started</a>
            <div className="secondary-buttons">
              <Link to="/services" className="text-button">Our Services <span className="arrow">→</span></Link>
              <a href="#insurance" className="text-button">Insurance & Payment <span className="arrow">→</span></a>
            </div>
          </div>
        </div>
        <div className="hero-images">
          <div className="image-container">
            <div className="left-images">
              <div className="image image-1">
                <img src={heroImage1} alt="Medical professional" />
              </div>
              <div className="image image-2">
                <img src={heroImage2} alt="Medical facility" />
              </div>
            </div>
            <div className="image image-3">
              <img src={heroImage3} alt="Patient care" />
            </div>
          </div>
        </div>
      </div>
      <CareTypeModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </section>
  );
};

export default Hero;
